import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from '../../ScoreboardCells.module.scss';

type MatchScoreboardCell = PropsWithChildren<{
  className?: string;
}>;

const MatchScoreboardCell: FC<MatchScoreboardCell> = ({ className, children }) => {
  return (
    <div className={classNames(styles.matchScoreboardCell, className)}>
      {children}
    </div>
  );
};

export default MatchScoreboardCell;
